module.exports = __webpack_public_path__ + "static/media/icon_medic.10e61b4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_medic.png
// module id = 526
// module chunks = 0